import axios from "axios";

export default class BaseApi {
    static init(baseURL) {
        axios.defaults.baseURL = baseURL;
    }

    static stringify(data) {
        return window.qs.stringify(data);
    }
}